// Bridge root App: re-esporta la versione con AuthProvider e routing protetto
// definita in components/App.js per evitare doppio router / mancanza AuthContext.
import ComponentsApp from './components/App';
export default ComponentsApp;